'use strict'

// import { CookiePolicy } from './lib/CookiePolicy'
import { Svg } from './lib/Svg'
import { Smooth } from './lib/Smooth'
import { ScrollStatus } from './lib/ScrollStatus'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { ArticleSlider } from './lib/ArticleSlider'
import { Accordion } from './lib/Accordion'
import { ScheduleMore } from './lib/ScheduleMore'
import { SecondCampusSlider } from './lib/SecondCampusSlider'
import { DateMore } from './lib/DateMore'
import { CourseListModal } from './lib/CourseListModal'
import { StudentInterviewVideoModal } from './lib/StudentInterviewVideoModal'
// new CookiePolicy('optout')

new Svg()
new Smooth()
new ScrollAnimation()
new ArticleSlider()
new Accordion()
new ScheduleMore()
new SecondCampusSlider()
new DateMore()
new CourseListModal()
new StudentInterviewVideoModal()
